import { render } from "./ForecastUpdate.vue?vue&type=template&id=64437383"
import script from "./ForecastUpdate.vue?vue&type=script&lang=js"
export * from "./ForecastUpdate.vue?vue&type=script&lang=js"

import "./ForecastUpdate.vue?vue&type=style&index=0&id=64437383&lang=css"

import exportComponent from "/root/dirif/prod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__